import { Component, OnInit, OnDestroy } from '@angular/core';
import { Content } from '../../../models/page-contents';
import { AppContentsService } from '../../../services/app-contents.service';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-home-slider',
  templateUrl: './home-slider.component.html',
  styleUrls: ['./home-slider.component.css']
})
export class HomeSliderComponent implements OnInit, OnDestroy {
    private subscriptions: Array<ISubscription> = [];
    sliderProject: Content = new Content();
    sliderBibliography: Content = new Content();
    sliderManuscripts: Content = new Content();
    sliderStemma: Content = new Content();
    sliderEdition: Content = new Content();

    constructor(
        private appContentsService: AppContentsService) {
    }

    ngOnInit(): void {

        /* Page contents */
        this.subscriptions.push(
            this.appContentsService.getPageContents('home')
                .subscribe(
                    page => {
                        if (page && page.name === 'home') {
                            this.sliderProject = page.contents.find(c => c.name === 'slider-project');
                            this.sliderBibliography = page.contents.find(c => c.name === 'slider-bibliography');
                            this.sliderManuscripts = page.contents.find(c => c.name === 'slider-manuscripts');
                            this.sliderStemma = page.contents.find(c => c.name === 'slider-stemma');
                            this.sliderEdition = page.contents.find(c => c.name === 'slider-edition');
                        }
                    },
                    err => console.error(err)
                )
        );

    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/home-slider/home-slider.component.ts